import Service from "../../AuthService";
const material = {
    getMaterialInspect() {
        return Service.get("/material-inspection");
    },
    showMaterialInspect(id) {
        return Service.get("/material-inspection/"+id);
    },
    updateMaterialInspect(id,data) {
        return Service.put("/material-inspection/"+id ,data);
    },
    clearInspect(shift_id){
        return Service.post('clear-inspect?shift_id='+shift_id);
    },
    searchMaterialInspect(code){
        return Service.post('/material-inspection-search?code='+code);
    }
};
export default material;
